import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { DataTablesService } from './data-tables.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { HttpService } from '../../services/http-service/http.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { LocalInterfaceService } from '../../services/local-inteface-service/local-interface.service';
import { ValidationService } from '../../services/validation-service/validation.service';
import { StorageService } from '../../services/storege-service/storage.service';
import { ToastrService } from 'ngx-toastr';
import { ToolService } from '../../services/tool/tool.service';

@Component({
  selector: 'app-data-tables',
  templateUrl: './data-tables.component.html',
  styleUrls: ['./data-tables.component.scss'],
  providers: [DataTablesService],
  encapsulation: ViewEncapsulation.None,
})
export class DataTablesComponent {

  @ViewChild('dangerModal', { static: false }) public dangerModal: ModalDirective;


  bookingsList: any[] = [];

  error: any;
  public dbData?;
  public isLoading: boolean = true;
  public isDataLoading: boolean = false;
  public currentIndex = 0;
  public filterQuery = '';
  public btnLang: string;
  public langDir: string = 'ltr';
  public facilityId = '';
  public totalRecords = 0;
  public previousActivePage = 0;
  public nextActivePage = 0;  
  public courts 
  title = 'ng';
  langs = ['en', 'ar'];


  // tslint:disable-next-line:use-lifecycle-interface
  ngOnInit(): void {
    const browserlang = this.translateService.getBrowserLang();
    if (this.langs.indexOf(browserlang) > -1) {
      this.translateService.setDefaultLang(browserlang);
      this.btnLang = 'English';
      this.langDir = 'rtl';
    } else {
      this.translateService.setDefaultLang('en');
      this.btnLang = 'العربية';
      this.langDir = 'ltr';
    }
  }

  constructor(
    public translateService: TranslateService,
    public titleService: Title,
    public router: Router,
    public route: ActivatedRoute,
    private httpService: HttpService,
    private storageSrv: StorageService,
    private localInterfaceSrv: LocalInterfaceService,
    private toastr: ToastrService,
    private validationSrv: ValidationService,
    public toolService: ToolService,
  ) {
    if (this.router.getCurrentNavigation() != null && this.router.getCurrentNavigation().extras.state?.customerMobile != null) {
      this.filterQuery = this.router.getCurrentNavigation().extras.state?.customerMobile;
    }
    this.validationSrv.validateAcess()
    .then(async () => {
      this.isLoading = true;
      this.route.queryParams.subscribe(async params => {
        this.facilityId = this.storageSrv.getFacilityId();
          // await this.loadBookings(this.facilityId, 0, 100, true);
          await this.loadBookingByPagination();
          console.log('this.dbData',this.dbData);
          // debugger
      });
    });
  }

  // onBookingDateChange(event: any) {
  //   const listArray = this.dbData?.content?.slice(0);
  //   this.bookingsList = listArray.filter(item => {
  //     const itemDate = new Date(item.startTime).toISOString().split('T')[0];
  //     const targetDate = new Date(event).toISOString().split('T')[0];
  //     return itemDate === targetDate;
  //   });
  // }

  // updateBookingsList() {
  //   this.bookingsList = this.dbData?.content?.slice(0);
  // }

  loadBookings = (facilityId, pageNo, noOfRecords, firstLoad) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getBookings(facilityId, pageNo, noOfRecords)
        .then(res => {
          this.dbData = res;
          //this.updateBookingsList();
          this.isLoading = false;
          //this.totalRecords = Math.max(...res.content.map(o => o.totalRecords));
          resolve(res);
        })
        .catch(err => {
          reject(err);
          this.toolService.showConsoleLog(err);
          // this.toastr.error(err.description, "Error");
        })
        .finally(() => {
          this.isLoading = false
        });
    });
  }

  loadSeqBookings = (facilityId, pageNo, noOfRecords, firstLoad) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isDataLoading = true;
      this.localInterfaceSrv.getBookings(facilityId, pageNo, noOfRecords)
        .then(res => {
          this.dbData.content = [...this.dbData.content, ...res.content];
          //this.updateBookingsList();
          this.isDataLoading = false;
          const element = document.getElementById('paginator');
          element.style.pointerEvents = 'auto';
          resolve(res);
        })
        .catch(err => {
          reject(err);
          this.toolService.showConsoleLog(err);
          // this.toastr.error(err.description, "Error");
        })
        .finally(() => this.isLoading = false);
    });
  }

  toInt(num: string) {
    return +num;
  }

  sortByWordLength = (a: any) => {
    return a.name.length;
  }

  getDate(regDate: string) {
    const date = new Date(regDate);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
    });
  }

  deleteBooking = (bookingId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      const fields = {
        bookingId: bookingId
      };
      this.localInterfaceSrv.deleteBooking(bookingId)
        .then(async res => {
          resolve(res);
          this.toastr.success('Booking Removed', 'Success');
          this.dangerModal.hide();
          this.route.queryParams.subscribe(async params => {
            await this.loadBookings(this.facilityId, 0, 100, true);
          });
          // window.location.reload()
        })
        .catch(err => {
          reject(err);
          this.toastr.error(err.description, 'Error');
          this.dangerModal.hide();
        })
        .finally(() => this.isLoading = false);
    });
  }
  showEdit(data: object|any) {
    this.router.navigate([`/booking/details/${data.id}`], {state: {bookingId: data.id}, relativeTo: this.route});
  }

  add() {
    this.router.navigate(['details'], { state: { createData: '' }, relativeTo: this.route });
  }

  async delete(content: object) {
    return await this.httpService.post('deleteUser', '', '')
      .then(
        data => { window.location.reload(); },
        error => {
          this.dangerModal.hide();
          // this.toastComp.doShow("Error", 'An error has occured, please try again later');
        }
      ).catch();
  }


  getBookingStatusColor = (val) => {
    switch (val) {
      case 'Cancelled':
        return 'danger';
      case 'Confirmed':
          return 'success';
      default:
        return 'warning';
    }
  }

  getPaymentStatusColor = (paymentStatus, totalPrice) => {
    if (totalPrice == 0) {
      return 'light'
    }
    switch (paymentStatus?.toLowerCase()) {
      case 'paid':
        return 'success';
      default:
        return 'warning';
    }
  }

  getChannelColor = (val) => {
    switch (val?.toLowerCase()) {
      case 'online':
        return 'info';
      default:
        return 'secondary';
    }
  }

  loadCourts = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.localInterfaceSrv.getCourts(this.facilityId)
      .then(res => {
        this.courts = res.content;

        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        
        this.toastr.error(err.description, "Error");
      })
    });
  }

  getCourtName = (courtId) => {
    const court=this.courts.find((element) => element.id == courtId);
    return court?.nameEn||""
  }

  onPageChange=async (updatedPage)=> {
    if(updatedPage===this.pageLimit)
    return
  
    this.pageLimit=updatedPage
    this.currentPage = 1;
    await this.loadBookingByPagination(1,updatedPage)

    // if (this.isDataLoading)
    // {
    //   const element = document.getElementById('paginator');
    //   element.style.pointerEvents = 'none';
    //   return;
    // }

    // this.toolService.showConsoleLog("(Object.keys(this.dbData.content).length" + (Object.keys(this.dbData.content).length));
    // this.toolService.showConsoleLog("this.totalRecords" + this.totalRecords);
    // this.toolService.showConsoleLog("this.previousActivePage" + this.previousActivePage);
    // this.toolService.showConsoleLog("this.nextActivePage" + this.nextActivePage);
    // this.previousActivePage = this.previousActivePage == 0 || this.nextActivePage > this.previousActivePage ? event.activePage : this.previousActivePage;
    // this.nextActivePage = event.activePage;
    // if (Object.keys(this.dbData.content).length >= this.totalRecords)
    // {
    //   return;
    // }
    // if (this.nextActivePage <= this.previousActivePage)
    // {
    //   return;
    // }
    // this.loadSeqBookings(this.facilityId, event.activePage-1, 50, false);
    // this.toolService.showConsoleLog(this.dbData.content);
    // // this.loadBookings(this.facilityId, event.activePage, 50, false);
    // this.toolService.showConsoleLog("ON page change" + event.activePage);
  }

  // previousPageClick=async()=>{
  //   console.log('previousPageClick Handler');
    
  //   const firstItem=this.dbData.content[0]
  //   // await this.loadBookingByPagination(firstItem?.id,"pre")
  // }

  // nextPageClick=async()=>{
  //   console.log('nextPageClick Handler');
  //   const temp=[...this.dbData.content]
  //   const lastItem=temp.pop()
  //   // await this.loadBookingByPagination(lastItem?.id,"next")

  // }

  currentPage: number = 1;
  totalPages: number = 1;
  pageLimit: number =10
  totalPageLimits: number[] = [5,10,20]

  private timer: any; 

  onPaginationChange=async(page: number)=> {
    this.currentPage = page;
    // this.filterQuery=""
    await this.loadBookingByPagination(page)
  }

  handleSearch=async (event:Event)=>{
    const inputValue = (event.target as HTMLInputElement).value;  
    this.currentPage=1
    await this.loadBookingByPagination(1,this.pageLimit,inputValue)
  }

  handleDelayedSearch(event: Event): void {
    const delay = 500; // milliseconds
    clearTimeout(this.timer);

    this.timer = setTimeout(() => {
      this.handleSearch(event);
    }, delay);
  }

  loadBookingByPagination = (updatedPage?,updatedLimit?,searchString?) => {
    const qValue=searchString||this.filterQuery
    const obj={ facilityId: this.facilityId,
      admin:true,
      page: updatedPage||this.currentPage,
      limit:updatedLimit||this.pageLimit,
      ...(qValue?{q: qValue}:{}),
      //  ...(cursor?{cursor: cursor}:{}), 
      }
    const params = new URLSearchParams(obj as any);
    const queryString = params.toString();
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getAllBookings(queryString)
      .then(async res => {
        this.totalPages=res.data.content.pages
        if(this.totalRecords<=0)
        {
          this.totalRecords=res.data.content.count
        }
        this.dbData = {content:res.data.content.bookings,count:this.totalRecords};
        await this.loadCourts()
        this.isLoading = false;
        resolve(res);
      })
      .catch(err => {
        reject(err);
        console.log(err);
        // this.toastr.error(err.description, "Error");
      })
      .finally(() => {
        this.isLoading = false
      });
    });
  }
}
